import React, { useRef, useEffect, useState } from "react";
import { gsap } from "gsap";
import { useCountUp } from "react-countup";
import "./Statistics.scss";

function Statistics() {
  const barRef = useRef();
  const [showCounter, setShowCounter] = useState(false);

  useEffect(() => {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: barRef.current,
        start: "top 75%",
        end: "top 75%",
        once: true,
        onEnter: () => {
          setShowCounter(true);
        },
      },
    });
    tl.to("#bar96", { width: "96%", duration: 1.2 }).to(
      "#bar83",
      { width: "83%", duration: 1.2 },
      "-=1.2"
    );
  }, []);

  const SimpleHook = () => {
    useCountUp({
      ref: "counter",
      end: 96,
      start: 0,
      duration: 1.2,
    });
    return <span id="counter" />;
  };
  const SimpleHook2 = () => {
    useCountUp({
      ref: "counter2",
      end: 83,
      start: 0,
      duration: 1.2,
    });
    return <span id="counter2" />;
  };

  return (
    <figure className="statistics">
      <div className="statistics__graphic">
        <div className="statistics__graphic__graph" ref={barRef}>
          <div className="bar">
            <div className="bar-left bar-left-96" id="bar96" />

            <p className="bar-number" id="num96">
              {showCounter ? <SimpleHook /> : `0`}%
            </p>
          </div>
          <p className="statistics__graphic__graph__copy">
            of first-time home buyers financed their purchase
          </p>
        </div>

        <div className="statistics__graphic__graph statistics__graphic__graph--bottom">
          <div className="bar">
            <div className="bar-left bar-left-83" id="bar83" />
            <p className="bar-number " id="num83">
              {showCounter ? <SimpleHook2 /> : `0`}%
            </p>
          </div>
          <p className="statistics__graphic__graph__copy">
            of repeat home buyers financed their purchase
          </p>
        </div>
      </div>
      <figcaption className="captions">
        Source: NAR, 40th Anniversary Top 10 Highlights: Profile of Home Buyers
        and Sellers
      </figcaption>
    </figure>
  );
}

export default Statistics;
